import { Box, CircularProgress, Container, Grid } from '@mui/material';
import { useCheckLogin } from '_api';
import { User } from '_api/types';
import { ProfileCard } from 'components/organisms';
import { ProfileForm } from 'components/organisms/forms';
import { noop } from 'lodash';
import React, { useMemo } from 'react';

import { ProfileSubHeader } from './styles';

export const Profile = () => {
  const { data: account, isLoading: gettingId } = useCheckLogin();

  const user = useMemo(() => account as User, [account]);
  const isLoading = useMemo(() => gettingId, [gettingId]);
  return (
    <Container>
      {user && !isLoading ? (
        <Grid container spacing={2} columnSpacing={15}>
          <Grid item xs={12} md={4}>
            <ProfileCard account={user} />
          </Grid>
          <Grid item xs={12} md={8}>
            <Box>
              <ProfileSubHeader>Hello, {user.firstName}</ProfileSubHeader>
              <ProfileForm profile={user} isLoading={isLoading} onSubmit={noop} />

              {/*To be done after customer testing is complete*/}

              {/*{user.accountType === ACCOUNT_TYPE.ADMIN || ACCOUNT_TYPE.HOS_ADMIN || ACCOUNT_TYPE.ORG_ADMIN ? (*/}
              {/*  <>*/}
              {/*    <ProfileSubHeader>Notifications</ProfileSubHeader>*/}
              {/*    <Box onClick={() => console.log("clicked")}>*/}
              {/*      <Grid container spacing={2}>*/}
              {/*          <FormControlLabel*/}
              {/*            control={<Checkbox />}*/}
              {/*            label={"Allow guardians to contact therapists through the app"}*/}
              {/*          />*/}
              {/*      </Grid>*/}
              {/*    </Box>*/}
              {/*  </>*/}
              {/*) : null}*/}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};
